'use client';

import type { AppDispatch } from '@/src/store';
import { resetEarnPoolsUiFilters } from '@/src/store/reducers/AppReducer';
import { useEffect, type ReactNode } from 'react';
import { useDispatch } from 'react-redux';

interface EarnGateProps {
  children: ReactNode;
}

const EarnGate: React.FC<EarnGateProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    return () => {
      dispatch(resetEarnPoolsUiFilters());
    };
  }, [dispatch]);

  return <>{children}</>;
};

export default EarnGate;
